<div class="hpanel margin-bottom-5">

  <div class="panel-body add-cls border-radius-top-left-right-6" >
    <div class="row">
      <div class="col-lg-12 wig-c">
        {{headerTitle}}
      </div>
    </div>

    <!-- No data message -->
    <div class="gs-empty">
      <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
      <div class="gs-empty-title">No promoted ads yet</div>
      <div class="gs-empty-sub">Promoted ads will appear here when available.</div>
    </div>

  </div>
</div>
